//共用组件
import SvgIcon from "./SvgIcon.vue";

export const setupGlobComponents = (app) => {
    app.component("SvgIcon", SvgIcon);
}